export default __webpack_public_path__ + "static/media/s-pet-profile.28eb962c.webp";